import UAParser from "ua-parser-js";
import { offerEvent } from "./api";

export const offerRequestData = (eventMetaData) => {
  const mId = localStorage.getItem("mId") || "2026";
  const uuid = localStorage.getItem("uuid");
  const session_id = localStorage.getItem("session_id");
  const ip_address = localStorage.getItem("ip_address") || "";

  const parser = new UAParser();
  const result = parser.getResult();

  return {
    machine_id: mId,
    device_id: uuid,
    session_id,
    user_id: localStorage.getItem("userId"),
    ip_address,
    lat: "",
    lng: "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    deviceBrand: result.device.vendor || "Unknown",
    deviceModel: result.device.model || "Unknown",
    deviceType: result.device.type || "desktop",
    osName: result.os.name || "Unknown",
    osVersion: result.os.version || "Unknown",
    browserName: result.browser.name || "Unknown",
    browserVersion: result.browser.version || "Unknown",
    event_ts: Date.now().toString(),
    ...eventMetaData,
  };
};

export const logEvent = (eventMetaData) => {
  const requestData = offerRequestData(eventMetaData);
  offerEvent(requestData);
};
